// 다크모드 전역 공유 상태 (2026-07-30)
// 헤더 아이콘 토글 + 프로필 메뉴 항목이 같은 상태를 공유하도록 모듈 레벨 ref 사용.
import { ref } from 'vue';

const isDark = ref(false);
let initialized = false;

function apply() {
    if (isDark.value) {
        document.documentElement.classList.add('dark');
        localStorage.setItem('theme', 'dark');
    } else {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('theme', 'light');
    }
}

function initDarkMode() {
    if (initialized) return;
    initialized = true;
    const saved = localStorage.getItem('theme');
    isDark.value = saved
        ? saved === 'dark'
        : window.matchMedia('(prefers-color-scheme: dark)').matches;
    apply();
    // 저장된 명시적 선택이 없을 때만 시스템 변경을 따름
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        if (!localStorage.getItem('theme')) {
            isDark.value = e.matches;
            apply();
        }
    });
}

function toggleDarkMode() {
    isDark.value = !isDark.value;
    apply();
}

export function useDarkMode() {
    return { isDark, toggleDarkMode, initDarkMode };
}
